import { BasicComponent, ComponentChild, ComponentChildren } from "haxt";

import "./GridSection.scss";

export class GridSection extends BasicComponent<{
	class?: JSX.HTMLAttributes["class"];
	style?: JSX.HTMLAttributes["style"];
	[BasicComponent.Children]?: ComponentChildren;
}> {

	protected override receivedProps(props: any, children: ComponentChild[]): void {
		super.receivedProps(props, children);
		// schedule an update to render with new props
		// TODO: better handling?
		this.update();
	}

	public render() {
		let cls = BasicComponent.mergeClasses(
			{ GridSection: true },
			this.props.class
		);
		return (
			<div class={cls} style={this.props.style}>
				<div class="container">
					{this.children}
				</div>
			</div>
		);
	}
}
